import { mapActions, mapState } from 'vuex'
// import Language from '@/constants/lang'
import Actions from '@/constants/action'
import RouterName from '@/constants/route'
import { loading } from '@/mixin'
import { upload } from '@/mixin/file'

export const logic = {
  mixins: [loading, upload],
  data() {
    return {
      active: this.$route.query.active || 'document',
      eventCode: this.$route.query.code,
      eventId: this.$route.query.eventId,
      eventCampaignId: this.$route.query.eventCampaignId || this.$route.query.campaignId
    }
  },
  computed: {
    ...mapState(['userInfo', 'language', 'eventList', 'loading', 'campaignId']),

    // for apply
    ...mapState(['applyLookups']),

    // for desktop
    ...mapState(['registeredEvents', 'approvedEvents', 'lookups']),
    cLoading() {
      return this.loading.eventListLoading || this.loading.registerEventLoading
    },
    /* for event list*/
    cCurrent() {
      const prods = this.applyLookups.products || []
      const evts = this.eventList || []
      switch (this.active) {
        case 'event':
          if (evts && evts.length > 0) {
            return 'EventList'
          } else {
            return 'SelfCenter'
          }
        case 'document':
          if (prods && prods.length > 0) {
            return 'ProductList'
          } else {
            return 'SelfCenter'
          }
        case 'self':
          return 'SelfCenter'
      }
      return ''
    },
    cEventList() {
      return this.eventList
    },
    cProductList() {
      return this.applyLookups.products || {}
    }
  },
  created() {
    if (this.eventId) {
      return this.handleGoEventDetail({ id: this.eventId }, 1) // direct register
    }
    if (this.eventCode && this.active === 'event') {
      this.getEventsByCode({
        campaignCode: this.eventCode
      }).then(event => {
        return this.handleGoEventDetail(event)
      })
    }
    this.getBaseInfo()
    const temp = {
      campaignCode: this.eventCode || this.userInfo.campaignCode,
      campaignId: this.campaignId || this.userInfo.campaignId || this.eventCampaignId
    }
    this.fetchEventList(temp)
    this.getApplyLookups({
      campaignCode: this.eventCode || this.userInfo.campaignCode
    })
  },
  methods: {
    ...mapActions({
      updateUserInfo: Actions.UPDATE_USER_LOCAL_INFO,
      fetchEventList: Actions.GET_TOP_EVENTS,
      registerEvent: Actions.REGISTER_EVENT,
      updateAvatar: Actions.UPDATE_AVATAR,
      getEventsByCode: Actions.GET_EVENTS_BY_CODE,
      getBaseInfo: Actions.GET_BASE_INFO,
      logout: Actions.LOGOUT
    }),

    // for apply
    ...mapActions({
      getApplyLookups: Actions.GET_APPLY_LOOKUPS
    }),

    // for desktop
    ...mapActions({
      getRegisteredEvents: Actions.GET_REGISTED_EVENTS,
      getApprovedEvents: Actions.GET_APPROVED_EVENTS,
      fetchLookups: Actions.GET_LOOKUP,
      updateUserInfo: Actions.UPDATE_USER_INFO
    }),

    handleGoEventDetail(event, needRegister = 0) {
      this.$router.replace({
        name: RouterName.eventDetail,
        query: {
          eventId: event.id,
          register: needRegister,
          active: 'event',
          isRequiredCv: event.isRequiredCV,
          campaignId: this.eventCampaignId
        }
      })
    },
    handleUpdateAvatar(e, dir, isPublic) {
      this.uploadFile(e, dir, isPublic).then(key => {
        return this.updateAvatar({
          item: key
        })
      })
    },
    handleGoEditInfo() {
      this.$router.replace({
        name: RouterName.selfInfo
      })
    },
    handleGoCoupon() {
      this.$router.replace({
        name: RouterName.coupon
      })
    },
    handleGoQRcode() {
      this.$router.replace({
        name: RouterName.qrcode
      })
    },
    handleGoRegistered() {
      this.$router.replace({
        name: RouterName.registeredEvents
      })
    },
    handleGoApproved() {
      this.$router.replace({
        name: RouterName.approvedEvents
      })
    },
  async  handleGoLogout() {
      const campaignCode = this.userInfo.campaignCode
      const query = {
        code: campaignCode
      }
      if (this.campaignId) {
        query.campaignId = this.campaignId
      }
      if (!this.campaignId && this.userInfo.campaignId) {
        query.campaignId = this.userInfo.campaignId
      }
      await this.logout()
      this.$router.replace({
         name: RouterName.login,
         query: query
      })
      location.reload()
    },
    handleGoPreview() {
      this.$router.replace({
        name: RouterName.preview,
        query: {
          active: 'document'
        }
      })
    },
    handleGoAdd() {
      this.$router.replace({
        name: RouterName.preview,
        query: {
          active: 'document'
        }
      })
    },
    handleRegister(event) {
      if (!this.userInfo.name) {
        /* have no basic info */
        this.$router.replace({
          name: RouterName.updateProfile,
          query: {
            from: RouterName.home,
            active: 'event',
            eventId: event.id,
            campaignId: event.eventCampaignId || event.campaignId,
            // tp: this.userInfo.programmeType,
            type: event.programmeTypeName.toLowerCase().includes('anchor')
              ? 0
              : 1
          }
        })
      } else {
        const params = { item: event.id, campaignId: event.eventCampaignId || event.campaignId }
        this.registerEvent(params)
      }
    }
  }
}
